import { css } from "@emotion/react";
import { bpoints } from "../../../../../Utils";

export function selectorCSS() {
    return css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .Container {
            display: flex;
            justify-content: center;
            gap: 1.5rem;
            width: 100%;
            flex-wrap: wrap;
        }

        .Empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            font-size: 0.95rem;
            color: #5e6a72;
            padding: 1.5rem 0;
            cursor: pointer;
            gap: 0.4rem;

            .Icon {
                font-size: 1.5rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .Loading {
                animation: spin 1s ease-in-out infinite;
            }

            @keyframes spin {
                to { transform: rotate(360deg); }
            }
        }

        .Disabled {
            cursor: default;
        }

        .CardContainer {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            flex: 1;
            min-width: 140px;
            max-width: 200px;
        }

        .Card {
            width: 100%;
            background: linear-gradient(to right, #34C6F1, #00BA6E);
            border-radius: 28px 28px 24px 24px;
            cursor: pointer;

            .contentCard {
                display: flex;
                flex-direction: column;
                align-items: center;
                background: white;
                padding: 1.2rem 1rem 0.6rem;
                border-radius: 27px 27px 0 0;
                margin-top: 1px;
                margin-left: 1px;
                margin-right: 1px;
                gap: 0.3rem;

                .logoArea {
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        max-height: 38px;
                        max-width: 110px;
                        object-fit: contain;
                    }

                    .fallbackName {
                        font-size: 1.1rem;
                        font-weight: 700;
                        color: #21588c;
                    }
                }

                .labelText {
                    font-size: 0.7rem;
                    color: #9ba3ab;
                    font-weight: 500;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                }
            }

            .footerCard {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0.6rem 0.8rem 0.7rem;
                border-radius: 0 0 24px 24px;

                .textContent {
                    display: flex;
                    align-items: baseline;
                    gap: 0.15rem;

                    .price {
                        font-size: 1.05rem;
                        font-weight: 700;
                    }

                    .text {
                        font-size: 0.7rem;
                        font-weight: 500;
                    }
                }
            }
        }

        .totalLine {
            font-size: 0.72rem;
            color: #9ba3ab;
            font-weight: 500;
            margin-top: 0.4rem;
            text-align: center;
        }

        /* ─── Logo loader while fetching insurances ─── */
        .ins-logo-loader {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 1.5rem 0;
            animation: ins-breathe 2.6s ease-in-out infinite;
        }

        .ins-loader-svg {
            width: 64px;
            height: auto;
            display: block;
            overflow: visible;
        }

        .ins-loader-path {
            stroke-dasharray: 600;
            stroke-dashoffset: 600;
            animation: ins-draw 2.6s ease-in-out infinite;
        }

        @keyframes ins-draw {
            0%   { stroke-dashoffset: 600; }
            45%  { stroke-dashoffset: 0;   }
            55%  { stroke-dashoffset: 0;   }
            100% { stroke-dashoffset: 600; }
        }

        .ins-loader-frase {
            display: block;
            margin-top: 0.65rem;
            font-size: 0.78rem;
            font-weight: 500;
            background: linear-gradient(91deg, #00BA6E 0%, #32B8DF 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: ins-fade 0.5s ease;
        }

        @keyframes ins-fade {
            from { opacity: 0; transform: translateY(4px); }
            to   { opacity: 1; transform: translateY(0); }
        }

        @keyframes ins-breathe {
            0%, 100% { transform: scale(0.96); opacity: 0.8; }
            50%      { transform: scale(1.04); opacity: 1;   }
        }

        .shadowCard {
            margin-top: 0.3rem;
            width: 80%;
            height: 0.6rem;
            border-radius: 467px;
            background: radial-gradient(50.94% 44.66% at 49.86% 50.14%, rgba(0, 0, 0, 0.1) 0%, rgba(217, 217, 217, 0.00) 100%);
        }

        @media (max-width: ${bpoints.mobile.w}px) {
            .Container {
                gap: 1rem;
            }

            .CardContainer {
                min-width: 120px;
                max-width: 160px;
            }

            .Card .contentCard {
                padding: 1rem 0.6rem 0.5rem;

                .logoArea {
                    height: 32px;

                    img {
                        max-height: 30px;
                        max-width: 85px;
                    }
                }
            }

            .Card .footerCard .textContent .price {
                font-size: 0.9rem;
            }
        }
    `;
}
